// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22Saj","location":"Header_location__3f4Vd"};